
const styles = {
  reset_stack: {
    pl: "10%",
    pr: "10%",
    borderRadius: "16px",
    pt: {
      xs: '30px',
      sm: '30px',
      md: '50px',
      lg: '56px',
      xl: '56px',
    },
    pb: {
      xs: '30px',
      sm: '30px',
      md: '50px',
      lg: '56px',
      xl: '56px',
    },
    width: {
      xs: '98%',
      sm: '98%',
      md: '98%',
      lg: '90%',
      xl: '90%',
    },
  },
  t_reset_password: { 
    fontSize: {
      xs: 20,
      sm: 20,
      md: 20,
      lg: 24,
      xl: 24,
    }, 
    textAlign: "center",
    fontFamily: "Inter",
    color: 'white' 
  },
  t_description: {  
    fontSize: {
      xs: 13,
      sm: 13,
      md: 13,
      lg: 14,
      xl: 14,
    }, 
    textAlign: "center",
    fontFamily: "Inter",
    fontWeight: "600",
    color: 'white' 
  },
}

export default styles;